class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector("form");
    facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

    //Reload important js functions
    let isSortOpen = false;
    let isFilterOpen = false;
    const toggleFilters = () => {
      const button = document.getElementById("filter-toggle");
      const filters = document.getElementById("FacetsWrapperDesktop");

      button &&
        button.addEventListener("click", () => {
          if (isSortOpen) {
            closeSort();

            setTimeout(() => {
              button.classList.toggle("open");
              filters.classList.toggle("visible");

              if (Array.from(filters.classList).includes("visible"))
                isFilterOpen = true;
              else isFilterOpen = false;
            }, 400);
          } else {
            button.classList.toggle("open");
            filters.classList.toggle("visible");

            if (Array.from(filters.classList).includes("visible"))
              isFilterOpen = true;
            else isFilterOpen = false;
          }
        });
    };

    const openFilters = () => {
      const button = document.getElementById("filter-toggle");
      const filters = document.getElementById("FacetsWrapperDesktop");

      closeSort();
      button.classList.toggle("open");
      filters.classList.toggle("visible");
    };

    const openFiltersIfQueryHasFopen = () => {
      const hash = window.location.hash;

      if (hash === "#fopen") {
        openFilters();
      }
    };

    const closeFilters = () => {
      const button = document.getElementById("filter-toggle");
      const filters = document.getElementById("FacetsWrapperDesktop");

      button && button.classList.remove("open");
      filters && filters.classList.remove("visible");

      isFilterOpen = false;
    };

    const toggleSort = () => {
      const button = document.getElementById("sort-toggle");
      const sort = document.getElementById("sort-panel");

      button &&
        button.addEventListener("click", () => {
          if (isFilterOpen) {
            closeFilters();

            setTimeout(() => {
              button.classList.toggle("open");
              sort.classList.toggle("visible");
              showShadowBackgroundOnSortClick();

              if (Array.from(sort.classList).includes("visible"))
                isSortOpen = true;
              else isSortOpen = false;
            }, 400);
          } else {
            button.classList.toggle("open");
            sort.classList.toggle("visible");
            showShadowBackgroundOnSortClick();

            if (Array.from(sort.classList).includes("visible"))
              isSortOpen = true;
            else isSortOpen = false;
          }
        });
    };

    const closeSort = () => {
      const button = document.getElementById("sort-toggle");
      const sort = document.getElementById("sort-panel");
      const sortShadow = document.getElementById("sort-shadow-bg");

      sortShadow && sortShadow.classList.remove("visible");
      button && button.classList.remove("open");
      sort && sort.classList.remove("visible");

      isSortOpen = false;
    };

    const closeSortMenuOnItemClick = () => {
      const sortItems = document.querySelectorAll(".sort-item");

      sortItems &&
        sortItems.forEach((item) => {
          item.addEventListener("click", () => {
            setTimeout(() => {
              closeSort();
              closeShadow();
            }, 200);
          });
        });
    };

    const closeShadow = () => {
      const shadow = document.getElementById("shadow-bg");

      shadow.classList.remove("visible");
    };

    const closeOnShadowClick = () => {
      const shadow = document.getElementById("shadow-bg");

      shadow &&
        shadow.addEventListener("click", () => {
          shadow.classList.remove("visible");
          closeFilters();
          closeSort();
        });
    };

    const closeFiltersOnCloseClick = () => {
      const close = document.getElementById("close-filter-mobile");

      close &&
        close.addEventListener("click", (e) => {
          e.preventDefault();
          closeFilters();
        });
    };

    const toggleFacetsAccordion = () => {
      const facetsSummary = document.querySelectorAll(
        "#FacetsWrapperDesktop .facets__summary"
      );
      let hasOpenItems = false;

      facetsSummary &&
        facetsSummary.forEach((facet) => {
          facet.addEventListener("click", (e) => {
            facetsSummary.forEach((_facet) => {
              if (_facet != facet) {
                if (
                  Array.from(_facet.parentElement.classList).includes("is-open")
                )
                  hasOpenItems = true;

                _facet.parentElement.classList.remove("is-open");
              }
            });

            if (hasOpenItems) {
              setTimeout(() => {
                facet.parentElement.classList.toggle("is-open");
              }, 400);
            } else {
              facet.parentElement.classList.toggle("is-open");
            }
          });
        });
    };

    const showShadowBackgroundOnSortClick = () => {
      const shadow = document.getElementById("sort-shadow-bg");
      const sort = document.getElementById("sort-panel");
      const viewportWidth = window.innerWidth;

      if (viewportWidth < 874) {
        if (Array.from(sort.classList).includes("visible")) {
          shadow.classList.add("visible");
        }
      }
    };

    const closeSortOnCloseClick = () => {
      const close = document.getElementById("close-sort-mobile");

      close &&
        close.addEventListener("click", (e) => {
          e.preventDefault();
          closeShadow();
          closeSort();
        });
    };

    const applyFilters = () => {
      // PROBABLY WILL ONLY CLOSE FILTERS MENU
      closeFilters();
    };

    const applySort = () => {
      // PROBABLY WILL ONLY CLOSE SORT MENU
      closeSort();
    };

    const applySortOnButtonClick = () => {
      const applyButton = document.getElementById("apply-sort-button");

      applyButton &&
        applyButton.addEventListener("click", (e) => {
          e.preventDefault();
          applySort();
          closeShadow();
        });
    };

    const applyFiltersOnButtonClick = () => {
      const applyButton = document.getElementById("apply-filters-button");

      applyButton &&
        applyButton.addEventListener("click", (e) => {
          e.preventDefault();
          applyFilters();
          closeFilters();
        });
    };

    toggleSort();
    toggleFilters();
    closeSortMenuOnItemClick();
    closeSort();
    applyFiltersOnButtonClick();
    applySortOnButtonClick();
    closeSortOnCloseClick();
    toggleFacetsAccordion();
    closeFiltersOnCloseClick();
    closeOnShadowClick();
    closeShadow();
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        //Reload important js functions
        let isSortOpen = false;
        let isFilterOpen = false;
        const toggleFilters = () => {
          const button = document.getElementById("filter-toggle");
          const filters = document.getElementById("FacetsWrapperDesktop");

          button &&
            button.addEventListener("click", () => {
              if (isSortOpen) {
                closeSort();

                setTimeout(() => {
                  button.classList.toggle("open");
                  filters.classList.toggle("visible");

                  if (Array.from(filters.classList).includes("visible"))
                    isFilterOpen = true;
                  else isFilterOpen = false;
                }, 400);
              } else {
                button.classList.toggle("open");
                filters.classList.toggle("visible");

                if (Array.from(filters.classList).includes("visible"))
                  isFilterOpen = true;
                else isFilterOpen = false;
              }
            });
        };

        const openFilters = () => {
          const button = document.getElementById("filter-toggle");
          const filters = document.getElementById("FacetsWrapperDesktop");

          closeSort();
          button.classList.toggle("open");
          filters.classList.toggle("visible");
        };

        const openFiltersIfQueryHasFopen = () => {
          const hash = window.location.hash;

          if (hash === "#fopen") {
            openFilters();
          }
        };

        const closeFilters = () => {
          const button = document.getElementById("filter-toggle");
          const filters = document.getElementById("FacetsWrapperDesktop");

          button && button.classList.remove("open");
          filters && filters.classList.remove("visible");

          isFilterOpen = false;
        };

        const toggleSort = () => {
          const button = document.getElementById("sort-toggle");
          const sort = document.getElementById("sort-panel");

          button &&
            button.addEventListener("click", () => {
              if (isFilterOpen) {
                closeFilters();

                setTimeout(() => {
                  button.classList.toggle("open");
                  sort.classList.toggle("visible");
                  showShadowBackgroundOnSortClick();

                  if (Array.from(sort.classList).includes("visible"))
                    isSortOpen = true;
                  else isSortOpen = false;
                }, 400);
              } else {
                button.classList.toggle("open");
                sort.classList.toggle("visible");
                showShadowBackgroundOnSortClick();

                if (Array.from(sort.classList).includes("visible"))
                  isSortOpen = true;
                else isSortOpen = false;
              }
            });
        };

        const closeSort = () => {
          const button = document.getElementById("sort-toggle");
          const sort = document.getElementById("sort-panel");

          button && button.classList.remove("open");
          sort && sort.classList.remove("visible");

          isSortOpen = false;
        };

        const closeSortMenuOnItemClick = () => {
          const sortItems = document.querySelectorAll(".sort-item");

          sortItems &&
            sortItems.forEach((item) => {
              item.addEventListener("click", () => {
                setTimeout(() => {
                  closeSort();
                  closeShadow();
                }, 200);
              });
            });
        };

        const closeShadow = () => {
          const shadow = document.getElementById("shadow-bg");

          shadow.classList.remove("visible");
        };

        const closeOnShadowClick = () => {
          const shadow = document.getElementById("shadow-bg");

          shadow &&
            shadow.addEventListener("click", () => {
              shadow.classList.remove("visible");
              closeFilters();
              closeSort();
            });
        };

        const closeFiltersOnCloseClick = () => {
          const close = document.getElementById("close-filter-mobile");

          close &&
            close.addEventListener("click", (e) => {
              e.preventDefault();
              closeFilters();
            });
        };

        const toggleFacetsAccordion = () => {
          const facetsSummary = document.querySelectorAll(
            "#FacetsWrapperDesktop .facets__summary"
          );
          let hasOpenItems = false;

          facetsSummary &&
            facetsSummary.forEach((facet) => {
              facet.addEventListener("click", (e) => {
                facetsSummary.forEach((_facet) => {
                  if (_facet != facet) {
                    if (
                      Array.from(_facet.parentElement.classList).includes(
                        "is-open"
                      )
                    )
                      hasOpenItems = true;

                    _facet.parentElement.classList.remove("is-open");
                  }
                });

                if (hasOpenItems) {
                  setTimeout(() => {
                    facet.parentElement.classList.toggle("is-open");
                  }, 400);
                } else {
                  facet.parentElement.classList.toggle("is-open");
                }
              });
            });
        };

        const showShadowBackgroundOnSortClick = () => {
          const shadow = document.getElementById("sort-shadow-bg");
          const sort = document.getElementById("sort-panel");
          const viewportWidth = window.innerWidth;

          if (viewportWidth < 874) {
            if (Array.from(sort.classList).includes("visible")) {
              shadow.classList.add("visible");
            }
          }
        };

        const closeSortOnCloseClick = () => {
          const close = document.getElementById("close-sort-mobile");

          close &&
            close.addEventListener("click", (e) => {
              e.preventDefault();
              closeShadow();
              closeSort();
            });
        };

        const applyFilters = () => {
          // PROBABLY WILL ONLY CLOSE FILTERS MENU
          closeFilters();
        };

        const applySort = () => {
          // PROBABLY WILL ONLY CLOSE SORT MENU
          closeSort();
        };

        const applySortOnButtonClick = () => {
          const applyButton = document.getElementById("apply-sort-button");

          applyButton &&
            applyButton.addEventListener("click", (e) => {
              e.preventDefault();
              applySort();
              closeShadow();
            });
        };

        const applyFiltersOnButtonClick = () => {
          const applyButton = document.getElementById("apply-filters-button");

          applyButton &&
            applyButton.addEventListener("click", (e) => {
              e.preventDefault();
              applyFilters();
              closeFilters();
            });
        };

        toggleSort();
        toggleFilters();
        closeSortMenuOnItemClick;
        closeSort();
        applyFiltersOnButtonClick();
        applySortOnButtonClick();
        closeSortOnCloseClick();
        toggleFacetsAccordion();
        closeFiltersOnCloseClick();
        closeOnShadowClick();
        closeShadow();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    // FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element)
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`
      ).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    // document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static updateURLHash(searchParams) {
    Array.prototype.contains = function (v) {
      for (var i = 0; i < this.length; i++) {
        if (this[i] === v) return true;
      }
      return false;
    };

    Array.prototype.unique = function () {
      var arr = [];
      for (var i = 0; i < this.length; i++) {
        if (!arr.contains(this[i])) {
          arr.push(this[i]);
        }
      }
      return arr;
    };

    var duplicates = searchParams.split("&");
    var uniques = duplicates.unique();
    var finalUrl = uniques.join();
    var collection_path = window.location.pathname;

    if (window.location.pathname == "/collections/all") {
      collection_path = "/collections/sorted-all";

      history.pushState(
        { finalUrl },
        "",
        `${collection_path}${finalUrl && "?".concat(finalUrl)}`
      );

      //   window.location.href = `${collection_path}${finalUrl && "?".concat(finalUrl)}`;

      //   history.pushState(
      //     { finalUrl },
      //     "",
      //     `${collection_path}`
      //   );

      //   location.reload();
    } else {
      history.pushState(
        { finalUrl },
        "",
        `${collection_path}${finalUrl && "?".concat(finalUrl)}`
      );
    }
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    var queryArr = searchParams.replace("?", "").split("&");
    var queryParams = [];

    for (var q = 0, qArrLength = queryArr.length; q < qArrLength; q++) {
      var qArr = queryArr[q].split("=");

      if (qArr[0] != "sort_by") {
        queryParams[q] = qArr[1];
      }
    }

    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll(
      "facet-filters-form form"
    );
    if (event.srcElement.className == "mobile-facets__checkbox") {
      const searchParams = this.createSearchParams(
        event.target.closest("form")
      );
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile =
        event.target.closest("form").id === "FacetFiltersFormMobile";

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === "FacetSortForm" ||
            form.id === "FacetFiltersForm" ||
            form.id === "FacetSortDrawerForm"
          ) {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === "FacetFiltersFormMobile") {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join("&"), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1
          );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event);
  }
}

customElements.define("facet-remove", FacetRemove);
